import React, { useRef } from "react";
import "../ReportingChart/ReportingChart.scss";
import { Row, Col } from "../../components/RowCol";
import {
  Modal,
  Box,
  Typography,
  Button as muiButton,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; // Import the close icon
//import 'bootstrap/dist/css/bootstrap.min.css';
import { Table, Button } from "react-bootstrap";
import styled from "styled-components";
//import Accordion from 'react-bootstrap/Accordion'
//import Panel from 'react-bootstrap/Panel'
import { Accordion } from "react-bootstrap-accordion";
import { Helmet } from "react-helmet";
import PillNav from "../../components/PillNav/PillNav";
//import diagReport from './DiagnosticReportFhir.json';
import { useEffect } from "react";
import { Icon, TableHead } from "@mui/material";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useState } from "react";
import { DoctorconsoleGrid } from "../../pages/doctor-console/StyledComponents";

const Dicom = ({ data }) => {
  const [resArr, setResArr] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  useEffect(() => {
    console.log("In dicom page ");
    setResArr(data);
    console.log(
      "Length of media array",
      data[0].singleFhirObjectEleArrays[0].mediaArray?.length
    );
    console.log(
      "Length of Binary array",
      data[0].singleFhirObjectEleArrays[0].attachmentArray?.length
    );
  }, []);
  function formatDate(dateString) {
    const [dateStr, offsetStr] = dateString.split("+");
    const [year, month, day, timeStr] = dateStr.split(/[-T]/);
    const [hour, minute, second] = timeStr.split(":");
    const [offsetHours, offsetMinutes] = offsetStr.split(".");
    const date = new Date(
      Date.UTC(
        year,
        month - 1,
        day,
        hour - offsetHours,
        minute - offsetMinutes,
        second
      )
    );
    const formattedDay = String(date.getUTCDate()).padStart(2, "0");
    const formattedMonth = String(date.getUTCMonth() + 1).padStart(2, "0");
    const formattedYear = date.getUTCFullYear();
    const formattedHours = String(date.getUTCHours()).padStart(2, "0");
    const formattedMinutes = String(date.getUTCMinutes()).padStart(2, "0");
    const amOrPm = date.getUTCHours() >= 12 ? "PM" : "AM";
    const formattedDate = `${formattedDay}-${formattedMonth}-${formattedYear} ${formattedHours}:${formattedMinutes} ${amOrPm}`;
    return formattedDate;
  }

  const viewAttachment = (attachment) => {
    console.log("Attachment", attachment);
    let videoRef = null; // Reference to the video element

    // Function to toggle video play/pause
    const toggleVideoPlayPause = () => {
      if (videoRef) {
        if (videoRef.paused) {
          videoRef.play();
        } else {
          videoRef.pause();
        }
      }
    };

    var byteCharacters = atob(attachment?.data);
    var byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], { type: attachment?.contentType });

    const url = window.URL.createObjectURL(blob);

    // Wrap the content in a div with overflow for scrollability
    let modalContent;
    if (attachment.contentType === "application/pdf") {
      modalContent = <iframe width="100%" height="100%" src={url}></iframe>;
    } else if (
      attachment.contentType === "application/jpeg" ||
      attachment.contentType === "application/jpg" ||
      attachment.contentType === "application/png"
    ) {
      // Display image files
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "80%",
            maxHeight: "700px",
          }}
        >
          <img src={url} alt="Attachment" />
        </div>
      );
    } else if (
      attachment.contentType === "application/mov" ||
      attachment.contentType === "application/rm" ||
      attachment.contentType === "application/mpg" ||
      attachment.contentType === "application/avi" ||
      attachment.contentType === "application/mp4"
    ) {
      // Display video files with controls and scrolling
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "100%",
          }}
        >
          <video
            ref={(ref) => (videoRef = ref)} // Set the video element reference
            width="100%"
            height="100%"
            controls
            autoPlay
            onClick={toggleVideoPlayPause} // Add click event to toggle play/pause
          >
            <source src={url} />
          </video>
        </div>
      );
    } else {
      // Default to displaying it as an image if content type is unknown
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "100%",
          }}
        >
          <img src={url} alt="Attachment" />
        </div>
      );
    }

    setModalContent(modalContent);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalContent(null);
  };

  return (
    <>
      <DoctorconsoleGrid>
        <br></br>
        <h1>Dicom Page</h1>
        {resArr.length > 0 ? (
          resArr.map((res) => (
            <>
              <h3></h3>
              {res.singleFhirObjectEleArrays !== undefined &&
                res.singleFhirObjectEleArrays.length > 0 &&
                res.singleFhirObjectEleArrays.map(
                  (singleFhirObjectEleArray) => (
                    <Accordion
                      title={
                        <span style={{ fontWeight: "bold" }}>
                          {singleFhirObjectEleArray?.compositionTitle}
                        </span>
                      }
                      show
                      style={{
                        // backgroundImage:
                        //   "url('../../assets/images/backgrounds/2.jpg')",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    >
                      <h4>
                        <b>Observation List: </b>
                      </h4>
                      {singleFhirObjectEleArray?.observationsArray?.length >
                      0 ? (
                        <Row
                          style={{
                            marginTop: "30px",
                            // backgroundImage:
                            //   "url('../../assets/images/backgrounds/2.jpg')",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        >
                          <Col
                            area="span 12"
                            style={{ border: "2px solid #76787a" }}
                          >
                            <Table bordered responsive size="lg">
                              <TableHead
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  gridTemplateColumns:
                                    "250px 250px 250px 120px 120px",
                                  justifyContent: "center",
                                }}
                              >
                                <td>Title</td>
                                <td>Date</td>
                                <td>Value</td>
                                <td>Reference Range</td>
                                <td>Unit</td>
                                <td>Status</td>
                              </TableHead>
                              <tbody>
                                {singleFhirObjectEleArray?.observationsArray?.map(
                                  (observationObj, ind) => (
                                    <tr>
                                      <td>
                                        {observationObj?.resource?.code?.text}
                                      </td>
                                      <td>
                                        {formatDate(
                                          observationObj?.resource
                                            ?.effectiveDateTime
                                        )}
                                      </td>
                                      <td>
                                        {parseFloat(
                                          observationObj?.resource
                                            ?.valueQuantity?.value
                                        ) >
                                          parseFloat(
                                            observationObj?.resource
                                              ?.referenceRange[0]?.high?.value
                                          ) ||
                                        parseFloat(
                                          observationObj?.resource
                                            ?.valueQuantity?.value
                                        ) <
                                          observationObj?.resource
                                            ?.referenceRange[0]?.low?.value ? (
                                          <div style={{ color: "red" }}>
                                            {
                                              observationObj?.resource
                                                ?.valueQuantity?.value
                                            }
                                          </div>
                                        ) : (
                                          <div>
                                            {
                                              observationObj?.resource
                                                ?.valueQuantity?.value
                                            }
                                          </div>
                                        )}
                                      </td>
                                      <td>
                                        {observationObj?.resource
                                          ?.referenceRange[0]?.high?.value +
                                          " - " +
                                          observationObj?.resource
                                            ?.referenceRange[0]?.low?.value}
                                      </td>
                                      <td>
                                        {
                                          observationObj?.resource
                                            ?.valueQuantity?.unit
                                        }
                                      </td>
                                      <td>
                                        {observationObj?.resource?.status}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      ) : (
                        <div
                          style={{
                            marginTop: "20px",
                            padding: "10px",
                            backgroundColor: "#3AC8BA",
                            fontWeight: "bold",
                            fontSize: "18px",
                          }}
                        >
                          No Observations found!
                        </div>
                      )}

                      <div
                        style={{
                          marginTop: "20px",
                          padding: "10px",
                          backgroundColor: "#f0f0f0",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        Conclusion : {singleFhirObjectEleArray?.conclusions}
                      </div>
                      <div
                        style={{
                          marginTop: "20px",
                          fontWeight: "bold",
                          marginBottom: "50px",
                          fontSize: "16px",
                        }}
                      >
                        Attachments :{" "}
                        {singleFhirObjectEleArray?.attachmentArray?.length > 0
                          ? singleFhirObjectEleArray?.attachmentArray.map(
                              (attachment) => (
                                <button
                                  style={{
                                    marginRight: "10px",
                                    backgroundColor: "#007bff",
                                    color: "#fff",
                                    border: "none",
                                    padding: "5px 10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => viewAttachment(attachment)}
                                >
                                  <i className="fas fa-file"></i>
                                </button>
                              )
                            )
                          : "No attachments found!"}
                        {singleFhirObjectEleArray?.mediaArray?.length > 0
                          ? singleFhirObjectEleArray?.mediaArray.map(
                              (attachment) => (
                                <button
                                  style={{
                                    marginRight: "10px",
                                    backgroundColor: "#007bff",
                                    color: "#fff",
                                    border: "none",
                                    padding: "5px 10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    viewAttachment(attachment.resource.content)
                                  }
                                >
                                  {attachment.resource.content.contentType ===
                                    "application/mov" ||
                                  attachment.resource.content.contentType ===
                                    "application/rm" ||
                                  attachment.resource.content.contentType ===
                                    "application/mpg" ||
                                  attachment.resource.content.contentType ===
                                    "application/avi" ||
                                  attachment.resource.content.contentType ===
                                    "application/mp4" ? (
                                    <i className="fas fa-play"></i>
                                  ) : (
                                    <i className="fas fa-file"></i>
                                  )}
                                </button>
                              )
                            )
                          : "No attachments found!"}
                      </div>
                    </Accordion>
                  )
                )}
            </>
          ))
        ) : (
          <div
            style={{
              marginTop: "20px",
              padding: "10px",
              backgroundColor: "#3AC8BA",
              fontWeight: "bold",
              fontSize: "25px",
            }}
          >
            No Diagnostic Report found!
          </div>
        )}
      </DoctorconsoleGrid>
      <Helmet>
        <link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
          rel="stylesheet"
          integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
          crossorigin="anonymous"
        />
      </Helmet>
      <Modal open={showModal} onClose={closeModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: "800px",
            height: "90%",
            maxHeight: "700px",
            bgcolor: "white",
            borderRadius: "8px",
            boxShadow: 24,
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton onClick={closeModal}>
              <CloseIcon />
            </IconButton>
          </div>
          {/* <Typography variant="h6">PDF Viewer</Typography> */}

          <div style={{ flex: 1 }}>{modalContent}</div>
        </Box>
      </Modal>
    </>
  );
};
const datapoints = [20, 50, 30, 20, 35, 40, 30, 20, 40, 30];
const state = {
  labels: [
    "Jan-2021",
    "Feb-2021",
    "Mar-2021",
    "Apr-2021",
    "May-2021",
    "Jun-2021",
    "Jul-2021",
    "Aug-2021",
    "Sep-2021",
  ],
  datasets: [
    {
      //label: 'Cubic interpolation (monotone)',
      label: "WBC Count",
      data: datapoints,
      //borderColor: 'rgba(255, 0, 0)',
      borderColor: "rgba(51, 0, 0, 0.8)",
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      borderWidth: 1.5,
      fill: false,
      //cubicInterpolationMode: 'monotone',
      tension: 0,
    },
    /*, {
        label: 'Cubic interpolation',
        data: datapoints,
        borderColor: 'rgba(0, 0, 255)',
        borderWidth: 1.5,
        fill: false,
        tension: 0.4
    }, {
        label: 'Linear interpolation (default)',
        data: datapoints,
        borderColor: 'rgba(0, 128 ,0)',
        borderWidth: 1.5,
        fill: false
    }*/
  ],
};

const progressColors = {
  green: "#01A601",
  pink: "#E87971",
  blue: "#05C4E2",
  orange: "#F66220",
};

const Progress = styled.div`
  height: 0.6rem;
  background-color: #ccd0d2;
  display: grid;
  grid-template-columns: ${(props) => props.width} calc(
      100% - ${(props) => props.width}
    );
  border-radius: 50px;
  width: 100%;
  .progress-item {
    height: 0.6rem;
    background-color: ${({ color }) => progressColors[color]};
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-radius: 50px;
    span {
      font-size: 0.8rem;
      color: #94999c;
      margin-top: -3rem;
    }
  }
  .bg {
    width: 100%;
  }
`;
const ProgressBar = ({ color, width }) => {
  return (
    <Progress color={color} width={width}>
      <div className="progress-item">
        <span>{width}</span>
      </div>
      <div className="bg"></div>
    </Progress>
  );
};
export default Dicom;
